import React from 'react';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import {
  TimePicker as MuiTimePicker,
  TimePickerProps as MuiTimePickerProps,
} from '@mui/x-date-pickers';

import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

import { ShowErrorFunc, showErrorOnChange } from './rff/Util';

interface TimePickerWrapperProps extends FieldRenderProps<MuiTimePickerProps<Date>> {
  required?: boolean;
  locale?: any;
}

function TimePickerWrapper(props: TimePickerWrapperProps) {
  const {
    input: { name, onChange, value, ...restInput },
    meta,
    readOnly,
    required,
    showError = showErrorOnChange,
    ...rest
  } = props;

  const { error, submitError } = meta;
  const isError = showError({ meta });

  const { helperText, slotProps, ...lessrest } = rest;

  return (
    <MuiTimePicker
      onChange={onChange}
      value={value || null}
      slotProps={{
        textField: {
          name,
          required,
          fullWidth: true,
          helperText: isError ? error || submitError : helperText,
          error: isError,
          inputProps: {
            onBlur: restInput.onBlur,
            onFocus: restInput.onFocus,
            readOnly,
          },
        },
        ...(slotProps || {}),
      }}
      {...lessrest}
    />
  );
}

export interface TimePickerProps extends Partial<Omit<MuiTimePickerProps<Date>, 'onChange'>> {
  name: string;
  locale?: any;
  fieldProps?: Partial<FieldProps<any, any>>;
  required?: boolean;
  showError?: ShowErrorFunc;
  inputReadOnly?: boolean;
}

export function KeyboardTimePicker(props: TimePickerProps) {
  const { isEditable } = useCanEditFormFieldsContext();
  const { name, fieldProps, required, disabled, inputReadOnly, ...rest } = props;
  const isDisabled = disabled || !isEditable;

  return (
    <Field
      name={name}
      disabled={isDisabled}
      render={(fieldRenderProps) => (
        <TimePickerWrapper
          required={required}
          readOnly={inputReadOnly}
          {...fieldRenderProps}
          {...rest}
        />
      )}
      {...fieldProps}
    />
  );
}
